import { score } from 'rtcscore/src/rtc_mos'; // webpack will not resolve this without referencing the file
import { RemoteVideoQualityStatsManager } from './remote_video_quality_stats_manager';
import { VIDEO_WIDTH, VIDEO_HEIGHT, FRAME_RATE as EXPECTED_FRAME_RATE } from '../constants';
// Stats will be averaged over this number of metrics collection periods
const OBSERVATION_PERIODS_TO_CONSIDER = 2;
export class RemoteVideoQualityScoreManager {
    constructor(_logger) {
        this._logger = _logger;
        this.calculateRemoteVideoQualityScore = ({ frameRate, codec, roundTripTime, bitRate, jitterBufferDelay, }) => {
            if (frameRate === 0) {
                this.logger.debug('frameRate is 0 😅');
                return undefined;
            }
            if (!roundTripTime) {
                this.logger.debug('roundTripTime not available 🤨');
                return undefined;
            }
            // Note that one weakness in rtcscore is that it uses bitrate, which varies depending on
            //     the video that is sent.  For example, if you have a very good connection, but the
            //     remote video does not change much from frame to frame, the bitrate will be low, causing
            //     the video score to be lower than expected.
            //
            // See the following confluence page for notes on customizing the scoring:
            //     https://ftdr.atlassian.net/wiki/spaces/VREXPERT/pages/2237497500/Customized+Network+Quality+Score+for+Video+Chime?force_transition=dd66f0df-7ba8-474c-a865-3768333844eb
            const scores = score({
                video: {
                    expectedWidth: VIDEO_WIDTH,
                    expectedHeight: VIDEO_HEIGHT,
                    expectedFrameRate: EXPECTED_FRAME_RATE,
                    codec,
                    bufferDelay: jitterBufferDelay,
                    roundTripTime,
                    bitrate: bitRate,
                    frameRate,
                },
            });
            const videoScore = scores.video;
            return videoScore != null ? Math.round(videoScore) : undefined;
        };
        this.logger = _logger.extend('sdk-chime-video:remote_video_quality_score_manager');
        this.remoteVideoQualityStatsManager = new RemoteVideoQualityStatsManager(OBSERVATION_PERIODS_TO_CONSIDER, _logger);
    }
    calculateScore(webRTCStats, remoteVideoEnabled) {
        this.remoteVideoQualityStatsManager.addObservation(webRTCStats, remoteVideoEnabled);
        const averages = this.remoteVideoQualityStatsManager.findAverages();
        if (averages == null) {
            return undefined;
        }
        const videoScore = this.calculateRemoteVideoQualityScore(averages);
        this.logger.debug('videoScore is', videoScore);
        return videoScore;
    }
}
//# sourceMappingURL=remote_video_quality_score_manager.js.map